if (document.getElementById("searchPage")) {
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearch);
  } else {
    initSearch();
  }

  function initSearch() {
    const cache = {};
    let isLoading = false;

    const results = document.getElementById('search-results');
    const spinner = document.getElementById('pilgrimSpinner');
    const prevBtn = document.getElementById('prev-button');
    const nextBtn = document.getElementById('next-button');
    const currentLbl = document.getElementById('current-paged');
    const maxLbl = document.getElementById('max-pages');
    const pagination = document.getElementById('pagination');

    if (!results || !spinner || !prevBtn || !nextBtn || !currentLbl || !maxLbl || !pagination) {
      console.warn('Faltan elementos del DOM para la búsqueda');
      return;
    }

    const ajaxUrl = typeof ajax_params !== 'undefined' ? ajax_params.ajax_url : '/wp-admin/admin-ajax.php';

    const params = new URLSearchParams(window.location.search);
    const currentQuery = params.get('s') || '';
    let currentPage = 1;

    // Si no hay query, no inicializar
    if (!currentQuery) return;

    function renderPagination(maxPages) {
      maxLbl.textContent = maxPages;

      prevBtn.disabled = currentPage <= 1;
      prevBtn.setAttribute('data-page', Math.max(1, currentPage - 1));

      nextBtn.disabled = currentPage >= maxPages;
      nextBtn.setAttribute('data-page', Math.min(maxPages, currentPage + 1));

      currentLbl.textContent = currentPage;
    }

    function renderResults(response) {
      if (!response || !response.html || !response.max_pages) {
        console.warn('Respuesta AJAX inválida:', response);
        return;
      }

      // Fade out
      results.style.opacity = '0';
      
      setTimeout(() => {
        results.innerHTML = response.html;
        // Fade in
        results.style.opacity = '1';
      }, 200);

      renderPagination(response.max_pages);
    }

    function fetchData(page, query) {
      const url = new URL(ajaxUrl);
      url.searchParams.append('action', 'loadMoreSearches');
      url.searchParams.append('page', page);
      url.searchParams.append('query', query);

      return fetch(url.toString(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        });
    }

    function preloadAdjacent(page, maxPages) {
      const nextPage = page + 1;
      const prevPage = page - 1;
      const promises = [];

      if (nextPage <= maxPages && !cache[nextPage]) {
        promises.push(
          fetchData(nextPage, currentQuery)
            .then(r => {
              cache[nextPage] = r;
            })
            .catch(err => console.error('Error preloading next:', err))
        );
      }

      if (prevPage >= 1 && !cache[prevPage]) {
        promises.push(
          fetchData(prevPage, currentQuery)
            .then(r => {
              cache[prevPage] = r;
            })
            .catch(err => console.error('Error preloading prev:', err))
        );
      }

      Promise.allSettled(promises);
    }

    function updateResults(page) {
      if (isLoading || page < 1) return;
      isLoading = true;
      currentPage = page;

      prevBtn.disabled = true;
      nextBtn.disabled = true;

      // Si está en caché, usar directamente
      if (cache[page]) {
        renderResults(cache[page]);
        preloadAdjacent(page, cache[page].max_pages);
        isLoading = false;
        prevBtn.disabled = false;
        nextBtn.disabled = false;
        return;
      }

      // Mostrar spinner
      pagination.style.display = 'none';
      spinner.style.display = 'block';

      fetchData(currentPage, currentQuery)
        .then(response => {
          cache[currentPage] = response;
          renderResults(response);
          preloadAdjacent(currentPage, response.max_pages);

          // Actualizar URL sin recargar
          const np = new URLSearchParams({ s: currentQuery });
          if (currentPage > 1) {
            np.set('paged', currentPage);
          } else {
            np.delete('paged');
          }
          history.replaceState(null, '', '?' + np.toString());
        })
        .catch((err) => {
          console.error('Error AJAX:', err);
        })
        .finally(() => {
          spinner.style.display = 'none';
          pagination.style.display = 'block';
          isLoading = false;
          prevBtn.disabled = false;
          nextBtn.disabled = false;
        });
    }

    function onNavClick(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const p = parseInt(this.getAttribute('data-page'), 10);
      if (!isNaN(p)) {
        updateResults(p);
      }
    }

    // Añadir transición CSS para el fade
    results.style.transition = 'opacity 0.2s ease-in-out';

    // Inicializar
    updateResults(1);
    prevBtn.addEventListener('click', onNavClick);
    nextBtn.addEventListener('click', onNavClick);
  }
}
